import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import logo from '../../images/logo.png';

const Loading = () => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100vh', background: 'white' }}>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Spin 
                indicator={<LoadingOutlined style={{ fontSize: 100, color: '#1677ff' }} spin />}
            />
            <img 
                src={logo} 
                alt="" 
                style={{ 
                    width: '50px', 
                    height: '50px', 
                    objectFit: 'contain',
                    position: 'absolute'
                }} 
            />
        </div>
    </div>
);

export default Loading;
